module.exports = __webpack_public_path__ + "static/img/camera.97d296a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/camera.png
// module id = eAMs
// module chunks = 1